import { render, staticRenderFns } from "./M22.vue?vue&type=template&id=4f2c6248"
import script from "./M22.vue?vue&type=script&lang=js"
export * from "./M22.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports